<template>
  <div class="history-section">
    <div class="section-header">
      <h3 class="section-title">{{ $t("globals.order") }}</h3>
    </div>

    <div class="filters-section">
      <div class="search-container">
        <input
          type="text"
          v-model="filter"
          :placeholder="$t('globals.type_to_search')"
          class="search-input"
        />
      </div>
      <button
        v-if="filter"
        class="search-btn clear-btn"
        @click="filter = ''"
      >
        {{ $t("globals.clear") }}
      </button>
    </div>

    <div class="table-wrapper">
      <table class="modern-table">
        <thead>
          <tr>
            <th @click="sortTable('agent')" class="sortable">
              {{ $t("globals.agent") }}
              <span class="sort-icon" v-if="sortBy === 'agent'">
                {{ sortDesc ? '▼' : '▲' }}
              </span>
            </th>
            <th @click="sortTable('action')" class="sortable">
              {{ $t("globals.action") }}
              <span class="sort-icon" v-if="sortBy === 'action'">
                {{ sortDesc ? '▼' : '▲' }}
              </span>
            </th>
            <th @click="sortTable('created')" class="sortable">
              {{ $t("globals.created") }}
              <span class="sort-icon" v-if="sortBy === 'created'">
                {{ sortDesc ? '▼' : '▲' }}
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paginatedItems" :key="item.created">
            <td>{{ item.agent }}</td>
            <td>{{ item.action }}</td>
            <td :title="item.created">{{ item.created ? item.created.substring(0, 10) : '' }}</td>
          </tr>
          <tr v-if="!logs || logs.length === 0">
            <td colspan="3" class="empty-state-cell">No history found</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div v-if="logs && logs.length > 0" class="pagination-section">
      <div class="controls-left">
        <span class="summary-label">{{ $t("globals.per_page") }}:</span>
        <select v-model="perPage" class="per-page-select">
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="30">30</option>
        </select>
        <span class="summary-label">
          {{ $t("globals.showing") }} {{ ((currentPage - 1) * perPage) + 1 }}-{{ Math.min(currentPage * perPage, filteredItems.length) }}
        </span>
      </div>
      <div class="pagination-controls">
        <button
          class="page-btn"
          @click="currentPage--"
          :disabled="currentPage === 1"
        >
          &lt;
        </button>
        <button
          class="page-btn"
          @click="currentPage++"
          :disabled="currentPage === totalPages"
        >
          &gt;
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      tableLoading: false,
      logs: [],
      filter: "",
      sortBy: "created",
      sortDesc: true,
      currentPage: 1,
      perPage: 10
    };
  },
  methods: {
    sortTable(field) {
      if (this.sortBy === field) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = field;
        this.sortDesc = false;
      }
    },
    fetchAudit() {
      this.tableLoading = true;
      this.logs = [];
      const data = {
        query: `
          query {
            orderAuditForOrder (order_id: ${parseInt(this.$route.params.id)}) {
              agent {
                full_name
              }
              action
              created_at
            }
          }
        `
      };

      axios
        .post(this.getGraphQlUrl, data, this.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
          } else {
            this.logs = res.data.data.orderAuditForOrder.map(log => {
              return {
                agent: log.agent.full_name,
                action: log.action.replace(/_/g, " "),
                created: log.created_at
              };
            });
          }
        })
        .catch(err => {
          alert(err);
          console.error(err);
        })
        .then(() => {
          this.tableLoading = false;
        });
    }
  },
  computed: {
    ...mapGetters(["getDefConf", "getGraphQlUrl"]),
    filteredItems() {
      if (!this.logs || this.logs.length === 0) return [];

      let items = [...this.logs];

      // Apply filter
      if (this.filter && this.filter.trim() !== "") {
        const filterLower = this.filter.toLowerCase();
        items = items.filter(item => {
          return (
            (item.agent && item.agent.toLowerCase().includes(filterLower)) ||
            (item.action && item.action.toLowerCase().includes(filterLower)) ||
            (item.created && item.created.toLowerCase().includes(filterLower))
          );
        });
      }

      // Apply sorting
      items.sort((a, b) => {
        let aVal = a[this.sortBy];
        let bVal = b[this.sortBy];

        if (aVal === null || aVal === undefined) return 1;
        if (bVal === null || bVal === undefined) return -1;

        if (typeof aVal === 'string') {
          aVal = aVal.toLowerCase();
          bVal = bVal.toLowerCase();
        }

        if (aVal < bVal) return this.sortDesc ? 1 : -1;
        if (aVal > bVal) return this.sortDesc ? -1 : 1;
        return 0;
      });

      return items;
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredItems.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredItems.length / this.perPage);
    }
  },
  watch: {
    filter() {
      this.currentPage = 1;
    }
  },
  mounted() {
    this.fetchAudit();
  }
};
</script>

<style scoped>
.history-section {
  padding: 0;
}

.clear-btn {
  background-color: #ed8936;
  color: white;
  border: none;
}

.clear-btn:hover {
  background-color: #dd6b20;
}
</style>
